export class People {
    id: string;
    name_ru: string;
    name_en: string;
    roles: number[];
    image: string;
    description: string;
    email: string;
    country: string;
}
